import { Container, Sprite, Texture } from "pixi.js";
import { AssetKeys } from "./Assets";

interface Particle {
  sprite: Sprite;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  rotVel: number;
  scale0: number;
  gravity: number;
}

export class ParticleSystem extends Container {
  private live: Particle[] = [];
  private idle: Sprite[] = [];
  private textures: Record<string, Texture>;

  constructor(textures: Record<string, Texture>) {
    super();
    this.textures = textures;
  }

  emitLeaves(x: number, y: number, count = 8) {
    for (let i = 0; i < count; i++) {
      const s = this.idle.pop() ?? this.createLeaf();
      s.position.set(x, y);
      s.alpha = 1;
      const scale0 = 0.18 + Math.random() * 0.22;
      s.scale.set(scale0);
      if (!s.parent) this.addChild(s);
      this.live.push({
        sprite: s,
        vx: (Math.random() - 0.5) * 280,
        vy: -160 - Math.random() * 220,
        life: 0,
        maxLife: 1.4 + Math.random() * 0.8,
        rotVel: (Math.random() - 0.5) * 6,
        scale0,
        gravity: 320,
      });
    }
  }

  update(dt: number) {
    for (let i = this.live.length - 1; i >= 0; i--) {
      const p = this.live[i];
      p.life += dt;
      if (p.life >= p.maxLife) {
        p.sprite.removeFromParent();
        this.idle.push(p.sprite);
        this.live.splice(i, 1);
        continue;
      }
      p.vy += p.gravity * dt;
      p.sprite.x += p.vx * dt;
      p.sprite.y += p.vy * dt;
      p.sprite.rotation += p.rotVel * dt;
      const lifeT = p.life / p.maxLife;
      p.sprite.alpha = 1 - lifeT;
      p.sprite.scale.set(p.scale0 * (1 - lifeT * 0.3));
    }
  }

  clear() {
    for (const p of this.live) {
      p.sprite.removeFromParent();
      this.idle.push(p.sprite);
    }
    this.live.length = 0;
  }

  private createLeaf() {
    const leaf = new Sprite(this.textures[AssetKeys.Leaf]);
    leaf.anchor.set(0.5);
    return leaf;
  }
}
